import React, {useEffect, useRef} from 'react';
import QuestionItem from "pages/Faq/components/QuestionItem";
import {Stack} from "@mui/material";
import {useQuestionListContext} from "pages/Faq/context/questionContext";
import CircularLoading from "components/CircularLoading";
import EmptyListText from "components/EmptyListText";


const QuestionList: React.FC = () => {
  const {questionList, loadingQuestions, isComeFromLink, openedByLinkQuestion, loading, selectedCategory, selectedSubCategory} = useQuestionListContext()
  const hasScrolled = useRef(false);

  useEffect(() => {
    if (!loading && !hasScrolled.current && isComeFromLink && openedByLinkQuestion) {
      setTimeout(() => {
        const element = document.getElementById(`question-${openedByLinkQuestion}`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          hasScrolled.current = true;
        }
      }, 100);
    }
  }, [loading, isComeFromLink, openedByLinkQuestion]);

  if (loadingQuestions) return <CircularLoading />
  return (
    <Stack spacing={2}>
      {
        !questionList?.length ?
          <EmptyListText>
            Пока нет опубликованных вопросов
          </EmptyListText>
          : questionList?.map((question, index) => (
        <QuestionItem
            key={index}
            selectedCategoryId={selectedCategory?.id}
            selectedSubCategoryId={selectedSubCategory}
            question={question}
            isComeFromLink={isComeFromLink}
            openByLink={openedByLinkQuestion}
            id={`question-${question.id}`}
        />
      ))}
    </Stack>
  );
};

export default QuestionList;
